/**
 * Mappers para o componente Result Member Profile
 */

import { NAME_FIELDS, AVATAR_FIELDS } from '../shared/avatar/avatar.constants';

/**
 * Obtém o nome do membro dos dados
 */
export function getMemberName(data: any): string {
    for (const field of NAME_FIELDS) {
        if (data[field]) {
            return data[field];
        }
    }
    return 'Membro';
}

/**
 * Obtém a foto do membro dos dados
 */
export function getMemberPhoto(data: any): string | null {
    for (const field of AVATAR_FIELDS) {
        if (data[field]) {
            return data[field];
        }
    }
    return null;
}

/**
 * Formata valor para exibição no perfil
 */
export function formatProfileValue(value: any, key: string): string {
    if (value === null || value === undefined) return '-';

    const lowerKey = key.toLowerCase();

    // Formatação de datas
    if (['data', 'date', 'nascimento', 'batismo', 'data_batismo', 'data_cadastro', 'created_at'].includes(lowerKey)) {
        return formatDate(value);
    }

    // Formatação de telefone
    if (['telefone', 'celular', 'phone', 'cellphone'].includes(lowerKey)) {
        return formatPhone(value);
    }

    // Formatação de CPF
    if (lowerKey === 'cpf') {
        return formatCPF(value);
    }

    // Formatação de estado civil
    if (lowerKey === 'estado_civil') {
        return formatMaritalStatus(value);
    }

    // Formatação de tipo de membro
    if (lowerKey === 'tipo') {
        return formatMemberType(value);
    }

    return String(value);
}

/**
 * Formata data para DD/MM/YYYY
 */
function formatDate(value: string): string {
    if (!value) return '-';

    // Se já está no formato DD/MM/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        return value;
    }

    // Se está no formato DDMMYYYY
    if (/^\d{8}$/.test(value)) {
        return `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`;
    }

    // Tenta converter de ISO
    try {
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('pt-BR');
        }
    } catch {
        // ignore
    }

    return value;
}

/**
 * Formata telefone
 */
function formatPhone(value: string): string {
    const digits = value.replace(/\D/g, '');

    if (digits.length === 11) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    }

    if (digits.length === 10) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    }

    return value;
}

/**
 * Formata CPF
 */
function formatCPF(value: string): string {
    const digits = value.replace(/\D/g, '');

    if (digits.length === 11) {
        return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
    }

    return value;
}

/**
 * Formata estado civil
 */
function formatMaritalStatus(value: string): string {
    const statuses: { [key: string]: string } = {
        'single': 'Solteiro(a)',
        'married': 'Casado(a)',
        'divorced': 'Divorciado(a)',
        'widowed': 'Viúvo(a)',
        'separated': 'Separado(a)'
    };

    return statuses[value.toLowerCase()] || value;
}

/**
 * Formata tipo de membro
 */
function formatMemberType(value: string): string {
    const types: { [key: string]: string } = {
        'member': 'Membro',
        'congregate': 'Congregado'
    };

    return types[value.toLowerCase()] || value;
}
